import CollectionReport from '../components/CollectionReport.jsx';
import MosaicReport from '../components/MosaicReport.jsx';
import NotFound from './NotFound.jsx';
import React from 'react';
import Spinner from '../components/Spinner.js';
import {TargetTypes} from '../util/feed.js';
import {Typography, styled} from '@mui/material';
import {getFeed, getSubscription} from '../api.js';
import {useParams} from 'react-router-dom';
import {useQuery} from '@tanstack/react-query';

const WIP = styled('div')({
  margin: 'auto',
});

const Subscription = () => {
  const {subscriptionId} = useParams();
  const subscriptionQuery = useQuery({
    queryKey: ['subscription', subscriptionId],
    queryFn: () => getSubscription(subscriptionId),
  });

  const subscription = subscriptionQuery.data;

  const feedQuery = useQuery({
    queryKey: [`feed/${subscription ? subscription.feedID : ''}`],
    queryFn: () => getFeed(subscription.feedID),
    enabled: !!subscription,
  });

  const feed = feedQuery.data;

  if (subscriptionQuery.isLoading || feedQuery.isLoading) {
    return <Spinner />;
  }

  if (!subscription || !feed) {
    return <NotFound />;
  }

  let Report;
  switch (feed.target.type) {
    case TargetTypes.MOSAIC: {
      Report = MosaicReport;
      break;
    }
    case TargetTypes.COLLECTION: {
      Report = CollectionReport;
      break;
    }
    default: {
      Report = (
        <WIP>
          <Typography variant="h5">
            👷 {feed.target.type} feeds are not yet supported, come back soon!
          </Typography>
        </WIP>
      );
    }
  }

  return <Report feed={feed} subscription={subscription} />;
};

export default Subscription;
